import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { FeatureSection } from './components/FeatureSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { CalendarIcon, BellIcon, ShoppingCartIcon, SparklesIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-[#FBF3EA]" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-0">
      <Navbar data-id="element-1" />

      <Hero data-id="element-2" />

      <div id="features" data-id="element-3">
        <FeatureSection badge="Calendar" icon={CalendarIcon} title="See" highlight="everyone's week" description="View every family member's schedule side-by-side and plan your week together." imageUrl="https://cdn.magicpatterns.com/uploads/29fqUKkwBMumyW1XRJ67dd/0x0ss_(49).png" imageAlt="Weekly Family Calendar" reverse={false} bgColor="bg-[#FCEFE3]" blobColor="bg-white" data-id="element-4" />

        <FeatureSection badge="Reminders" icon={BellIcon} title="No more" highlight="reminding everyone" description="Keep tabs on today's tasks, scheduled to-dos, and private items — all in one place." imageUrl="https://cdn.magicpatterns.com/uploads/uJnK6AL69YHJozphtDQGvw/0x0ss_(51).png" imageAlt="Family Reminders" reverse={true} bgColor="bg-[#FBE5E5]" blobColor="bg-white" data-id="element-5" />

        <FeatureSection badge="Lists" icon={ShoppingCartIcon} title="Chores, shopping," highlight="and prep" description="Share grocery lists and chores so everyone knows what's needed — and what's done." imageUrl="https://cdn.magicpatterns.com/uploads/oRpeWn2bqAtYbUrWeo5GuZ/0x0ss_(50).png" imageAlt="Shared Lists" reverse={false} bgColor="bg-[#EBE5F5]" blobColor="bg-white" data-id="element-6" />

        <FeatureSection badge="All-in-one" icon={SparklesIcon} title="Never miss" highlight="today's plans" description="Planner, reminders, to-dos, calendar, and family feed — everything your family needs in one app." imageUrl="https://cdn.magicpatterns.com/uploads/pyxMP8wRQmsKsULPY2QFJV/0x0ss_(52).png" imageAlt="All-in-one Family App" reverse={true} bgColor="bg-[#FCEFE3]" blobColor="bg-white" data-id="element-7" />
      </div>

      <CtaSection data-id="element-8" />

      <Footer data-id="element-9" />
    </div>;
}